import React, { useEffect, useState } from "react";
import { DELETE_ALL, POST } from "../text-data";
import { ReloadBlackSvg } from "./Assets";
import SolidBlueBtn from "./buttons/SolidBlueBtn";
import Spinner from "./spinner/Spinner";

const DEFAULT_MIN_HEIGHT = 200; // Adjust as needed

function CountableTextAreaForReviewBox({
  defaultValue,
  textAreaRef,
  textAreaHeight,  
  onChange,
  onClear,
  placeholder = "",
  maxLength = 1000,
  loading,
  onCreateComment,
}) {
  const [text, setText] = useState(defaultValue || "");
  const [isScroll, setScroll] = useState(false);  
  const handleChange = (event) => {
    setText(event.target.value);
    onChange && onChange(event.target.value);
  };
  const clearText = () => {
    setText("");
  };
  const handleClear = () => {
    if (onClear) {
      onClear({ clearText });
      return;
    }
    clearText();
  };

  const calculateHeight = () => {
    if (textAreaRef.current) {
      // const computedStyle = window.getComputedStyle(textAreaRef.current);
      // const lineHeight = parseInt(computedStyle.lineHeight, 10);
      // const numberOfLines = textAreaRef.current.value.split("\n").length;
      // const padding =
      //   parseInt(computedStyle.paddingTop, 10) +
      //   parseInt(computedStyle.paddingBottom, 10);
      // const border =
      //   parseInt(computedStyle.borderTopWidth, 10) +
      //   parseInt(computedStyle.borderBottomWidth, 10);
      // const newHeight = Math.max(
      //   DEFAULT_MIN_HEIGHT,
      //   lineHeight * numberOfLines + padding + border
      // ); // Ensure minimum height
      // textAreaRef.current.style.height = `${newHeight}px`;

      // const box = document.querySelector('.review-box');
      //   if (!box) return;
      //   const h = box.offsetHeight;
      //   const d = window.innerHeight - h;
      //   if (d) {
      //     const textarea = textAreaRef.current;
      //     // const yy = d + 140;          
      //     const yy = d + 120;         
      //     // textAreaRef.current.style.height = yy > 200 ? yy : 200;          
      //     // setHeight(yy > 200 ? yy : 200);
      //     // setHeight(500)
      //     console.log(textAreaValueRef?.meHei);
      //     if (textAreaValueRef)
      //       textAreaValueRef.meHei = yy > 200 ? yy : 200;          
      //   }
        setScroll(
          textAreaRef.current.scrollHeight > textAreaRef.current.clientHeight
        );
    }
  };

  useEffect(() => {
    calculateHeight();
  }, [text]); // Re-calculate height on text change

  const characterCount = text.length;
  // const remainingChars = maxLength - characterCount;

  const onFocus = function() {    
    try {
      // if (window.appBridge) {      
      //   window.appBridge.setEnableScroll(false);          
      // }
      // textAreaRef.current.focus();
      setTimeout(function() {
        document.querySelector(".review-box-edit").scrollTop = 10000000000;
      }, 100);
      setTimeout(function() {
        document.querySelector(".review-box-edit").scrollTop = 10000000000;
      }, 200);
    } catch(e) {}
  }

  // const onBlur = function() {
  //   if (window.appBridge) {        
  //     window.appBridge.setEnableScroll(true);        
  //   }
  // }
  return (
    <div className={`weight-1 w-full flex flex-col ${isScroll ? "blur-top" : ""}`}>
      <div className="weight-1">
        <textarea        
          ref={textAreaRef}
          value={text}
          onChange={handleChange}
          style={{
            border: "none",
            paddingTop: 10,
            width: "100%",
            resize: "none",
            // height: textAreaHeight ?? DEFAULT_MIN_HEIGHT,
            minHeight: textAreaHeight ?? DEFAULT_MIN_HEIGHT,
            height: "100%",
          }}
          onFocus={onFocus}
          // onBlur={onBlur}
          placeholder={placeholder}
          onInput={calculateHeight}
        />
      </div>

      <div className="h-[130px]"></div>
      <div className="bg-white edit-review-btn px-5 absolutexxx fixed w-full bottom-2 left-0 pt-[5px]" style={{ zIndex: 1, bottom: 0, paddingBottom: "8px" }}>
        <div className="flex justify-between">
          <button className="flex items-center gap-0.5" onClick={handleClear}>
            <img className="w-3.5 h-3.5" src={ReloadBlackSvg}></img>
            <b className="text-xs">{DELETE_ALL}</b>
          </button>
          <span className="text-xs">
            <b
              className={
                characterCount > maxLength ? "text-red" : "text-darkblue"
              }
            >
              {characterCount}
            </b>
            <span style={{ color: "#B7BDCA" }}>/{maxLength}</span>
          </span>
        </div>
        <SolidBlueBtn
          disabled={loading}
          className="w-full mt-6 flex items-center justify-center"
          onClick={onCreateComment}
        >
          <Spinner isLoading={loading} />
          {POST}
        </SolidBlueBtn>
      </div>
    </div>
  );
}

export default CountableTextAreaForReviewBox;
